var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.25C11.9142 17.25 12.25 16.9142 12.25 16.5V10.5C12.25 10.0858 11.9142 9.75 11.5 9.75C11.0858 9.75 10.75 10.0858 10.75 10.5V16.5C10.75 16.9142 11.0858 17.25 11.5 17.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5C12.0523 6.5 12.5 6.94772 12.5 7.5C12.5 8.05228 12.0523 8.5 11.5 8.5C10.9477 8.5 10.5 8.05228 10.5 7.5C10.5 6.94772 10.9477 6.5 11.5 6.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 11.5C0.75 5.56294 5.56294 0.75 11.5 0.75C17.4371 0.75 22.25 5.56294 22.25 11.5C22.25 17.4371 17.4371 22.25 11.5 22.25C5.56294 22.25 0.75 17.4371 0.75 11.5ZM11.5 2.25C6.39137 2.25 2.25 6.39137 2.25 11.5C2.25 16.6086 6.39137 20.75 11.5 20.75C16.6086 20.75 20.75 16.6086 20.75 11.5C20.75 6.39137 16.6086 2.25 11.5 2.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlined);
export default __webpack_public_path__ + "static/media/info-outlined.faf597e7abd8a22979088e2c1ad627dd.svg";
export { ForwardRef as ReactComponent };